import type { NovoGrupoDialogProps } from "./types-novo-grupo-dialog";
import { useNovoGrupoDialog } from "./use-novo-grupo-dialog";
import { NovoGrupoDialogView } from "./view-novo-grupo-dialog";

export function NovoGrupoDialog(props: NovoGrupoDialogProps) {
  const vm = useNovoGrupoDialog(props);

  return <NovoGrupoDialogView {...vm} />;
}

export type * from "./types-novo-grupo-dialog";
